import { render } from "./PreviewArticle.vue?vue&type=template&id=a3d5154e&ts=true"
import script from "./PreviewArticle.vue?vue&type=script&lang=ts"
export * from "./PreviewArticle.vue?vue&type=script&lang=ts"

import "./PreviewArticle.vue?vue&type=style&index=0&id=a3d5154e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__